import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "_flexcol" }
const _hoisted_3 = { class: "_flexcol" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_three_state_checkbox_field = _resolveComponent("three-state-checkbox-field")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _normalizeProps(_guardReactiveProps({..._ctx.$attrs, ..._ctx.$props})), {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.optionsWithExpanded, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option.name,
          class: "_flex _gap-1",
          "data-qa": `checkbox-group:${option.index}`
        }, [
          _createVNode(_component_base_icon, {
            name: option.iconName,
            class: "_tc--accent _cur-p _flex gfu-icon--collapsible",
            onClick: $event => ($options.toggleExpand(option)),
            "data-qa": "toggle-expand"
          }, null, 8 /* PROPS */, ["name", "onClick"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_three_state_checkbox_field, {
              "model-value": $options.parentValue(option),
              "display-name": option.name,
              "checked-value": option.name,
              inline: true,
              condensed: true,
              disabled: option.isDisabled,
              "onUpdate:modelValue": $event => ($options.toggleAllSubOptions(option)),
              "data-qa": "grouped-checkbox-option"
            }, null, 8 /* PROPS */, ["model-value", "display-name", "checked-value", "disabled", "onUpdate:modelValue"]),
            (option.subOptions?.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(['gfu-collapsible _pa-0 _bd--none', { 'gfu-collapsible--expanded': option.expanded }]),
                  "data-qa": "grouped-checkbox-suboptions"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['gfu-collapsible__content _pa-0 _bgc--white', { 'gfu-collapsible__content--expanded': option.expanded }])
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option.subOptions, (subOption) => {
                        return (_openBlock(), _createBlock(_component_checkbox_field, {
                          key: 'grouped-checkbox-sub-item:' + subOption.value,
                          "model-value": _ctx.modelValue,
                          "display-name": subOption.name,
                          "checked-value": subOption.value,
                          inline: true,
                          disabled: option.isDisabled,
                          condensed: true,
                          class: "_pl-5",
                          "onUpdate:modelValue": $options.onSubOptionInput,
                          "data-qa": `grouped-checkbox-sub-item:${subOption.value}`
                        }, null, 8 /* PROPS */, ["model-value", "display-name", "checked-value", "disabled", "onUpdate:modelValue", "data-qa"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ], 2 /* CLASS */)
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ])
        ], 8 /* PROPS */, _hoisted_1))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */))
}